import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";
import hme_gry from "../../assets/images/hme_gry.png";
import msg_blu from "../../assets/images/msg_blu.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import apiEndpoint from "../../core/apiend_point";
import { getLocalStorage } from "../../core/localStorageService";
import { PayloadProps } from "../../core/schema";
import { triggerApi } from "../../services";
import moment from "moment";
import ImageViewer from "react-simple-image-viewer";

import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import BackSecion from "../common/header";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

/**
 * Renders Component.
 * @return {Messages} renders Component.
 */
export default function Messages() {
  const [studentMessages, setStudentMessages] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [documentExtension, setDocumentExtension] = useState("");
  const [document, setDocument] = useState<any>([]);
  const navigate = useNavigate();
  useEffect(() => {
    getStudentMessages();
  }, []);

  const getStudentMessages = () => {
    setIsLoading(true);
    // setIsLoginButton(true)
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        users_type_id: user?.student[0]?.users_type_id, //getLocalStorage('users_type_id'),
        page_count: 1,
      },
      method: "POST",
      apiUrl: apiEndpoint.getStudentMessages,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.statusCode && res.statusCode === "success") {
          setStudentMessages(res.data);
        } else {
          console.log(res);
        }
        //   setIsLoginButton(false);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="cmmn">
        <Row className="p-3 mx-auto justify-content-between">
          <Col
            xs={5}
            className="d-flex justify-content-center align-items-center inactive_clr"
            onClick={() => navigate("/home")}
          >
            <img
              src={hme_gry}
              alt="..."
              className=""
              width="15px"
              height="15px"
            />
            <span
              role="button"
              className="f-14 text-decoration-none px-2 status_clr fw-bold link_style"
            >
              Home
            </span>
          </Col>
          <Col
            xs={5}
            className="col-5 d-flex justify-content-center align-items-center"
          >
            {" "}
            <img
              src={msg_blu}
              alt="..."
              className=""
              width="15px"
              height="15px"
            />
            <span
              role="button"
              className="fw-bold f-14 px-2 blue_clr link_style"
            >
              Messages
            </span>
          </Col>
        </Row>
        {isLoading && (
          <div className="loader">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        {!isLoading &&
          studentMessages.length > 0 &&
          studentMessages.map((item: any, i: number) => {
            let msg_color = "notice_green";
            if (item.type === "Holiday Message") {
              msg_color = "concern_msg";
            }
            return (
              <div className="row mx-auto mt-4 container" key={i}>
                <div className={`col-12 mx-auto rounded-3 pt-2 ${msg_color}`}>
                  <p className="f-13 m-0 clr_lightgry">{item.name}</p>

                  <p className="f-11 clr_lightgry">
                    {item.user_name}
                    <span className="pl-3 pr-3"> | </span>
                    {moment(item.sent_date).format("DD MMM mm:ss a")}
                  </p>

                  {item.attachments && (
                    <Col
                      xs={12}
                      className="f-12 pb-3 center-content"
                      onClick={() => {
                        setDocument([item.attachments]);
                        setShowDocument(true);
                        let extension = item.attachments.split(".").pop();
                        setDocumentExtension(extension);
                      }}
                    >
                      <img
                        src={item.attachments}
                        alt=""
                        width="300px"
                        height="180px"
                      />
                    </Col>
                  )}

                  <div className="col-10 p-0">
                    <p className="f-12 clr_lightgry">{item.message}</p>
                  </div>
                </div>
              </div>
            );
          })}

        <Modal
          show={showDocument}
          fullscreen={true}
          onHide={() => setShowDocument(false)}
        >
          <Modal.Body>
            <div onClick={() => setShowDocument(false)}>
              <BackSecion name="Messages" />
            </div>
            <div>
              {document !== "" && (
                <Row className="row mx-auto mt-4">
                  {documentExtension === "pdf" ? (
                    <Document
                      loading={`Loading...`}
                      file={document}
                      // onLoadSuccess={}
                    >
                      <Page pageNumber={1} />
                    </Document>
                  ) : (
                    <ImageViewer
                      src={document}
                      currentIndex={0}
                      disableScroll={false}
                      closeOnClickOutside={true}
                      onClose={() => {
                        setDocument([]);
                        setShowDocument(false);
                      }}
                      backgroundStyle={{'background':'transparent'}}
                    />
                  )}
                </Row>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
